import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import { DISBURSEMENT_OPTIONS } from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { getPermissions } from "../rbac/hasAccess";
import RequirementExcelDownload from "./requirementExcelDownload";
import { SUBTYPE_OPTIONS } from "./subtypes";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SearchToggleButton } from "../../utils/commonComponent/Custom/Button";

const headers = [
  "id",
  "allSubTypes",
  "jobNumber",
  "requestedName",
  "department",
  "l1ApproveStatus",
  "hodApproveStatus",
  "h1ApproveStatus",
  "h2ApproveStatus",
  "finalApproveStatus",
  "disbursedStatus",
  "date",
];

const excelHeaders = [
  { key: "Type", header: "Payment Type" },
  { key: "date", header: "Payment Date" },
  { key: "requestedName", header: "Beneficary Name" },
  { key: "bankAccountNumber", header: "Beneficary Account no" },
  { key: "ifscCode", header: "Bank code" },
  { key: "totalAmountOfReq", header: "Amount" },
  { key: "allSubTypes", header: "Narration" },
  { key: "allDescriptions", header: "Narration 2" },
  { key: "emailId", header: "Email Id" },
  { key: "debitAccountNumber", header: "Debit Account Number" },
];

const requirementExcelHeaders = [
  { key: "reqDate", header: "Requirement Date" },
  { key: "requestedName", header: "Requester Name" },
  { key: "requirmentType", header: "Requirement Type" },
  { key: "jobNumber", header: "Job Number" },

  { key: "siteName", header: "Site Name" },
  { key: "department", header: "Department" },
  { key: "totalAmount", header: "Total Amount" },
  { key: "Travelling", header: "Travelling" },
  { key: "Fuel Expense", header: "Fuel Expense" },
  { key: "Toll / Fast tag & Parking", header: "Toll / Fast tag & Parking" },
  { key: "Hotel / Lodging", header: "Hotel / Lodging" },
  { key: "Food / Meals", header: "Food / Meals" },
  { key: "Labour DA", header: "Labour DA" },
  { key: "Rent", header: "Rent" },
  { key: "Material Purchase", header: "Material Purchase" },
  {
    key: "Equipment Hire (Tractor/ Tanker/ Local Vehicle)",
    header: "Equipment Hire (Tractor/ Tanker/ Local Vehicle)",
  },
  { key: "Repair & Maintenance", header: "Repair & Maintenance" },
  { key: "Courier / Stationery", header: "Courier / Stationery" },
  { key: "Loading / Unloading Charges", header: "Loading / Unloading Charges" },
  { key: "Medical Expenses", header: "Medical Expenses" },
  { key: "Others", header: "Others" },
  { key: "Subcontractor Advance", header: "Subcontractor Advance" },
  { key: "Subcontractor Diesel", header: "Subcontractor Diesel" },
  { key: "Porter Charges", header: "Porter Charges" },
  {
    key: "Hydra/Farana Loading / Unloading Charges",
    header: "Hydra/Farana Loading / Unloading Charges",
  },
  {
    key: "Equipment - JCB / Water Tanker",
    header: "Equipment - JCB / Water Tanker",
  },
  {
    key: "Staff / Labour Drinking Water",
    header: "Staff / Labour Drinking Water",
  },
  { key: "Surveyor Charges", header: "Surveyor Charges" },
];

const fields = [
  { value: "jobNumber", label: "Job Number" },
  { value: "requestedName", label: "Requested Name" },
];

const STATUS_OPTIONS = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Pending", value: "Pending" },
];

const RequirementReport = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);

  const [requirementList, setRequirementList] = useState([]);
  const [allExcelData, setAllExcelData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [searched, setSearched] = React.useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [reportFilters, setReportFilters] = useState({
    subTypes: [],
    disbursementStatus: [],
  });
  const [inputStates, setInputStates] = React.useState({ approveStatus: [] });
  const [employeesData, setEmployeesData] = useState([]);
  const [jobData, setJobData] = useState([]);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
    setSearched(false);
  };

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getWhereClause = () => {
    const colMap = {
      jobNumber: "jr.jobNumber",
      requestedName: "e.name",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["r.status = 1"];

    // Search filter
    if (colName && key) {
      whereConditions.push(`${colName} LIKE '%${key}%'`);
    }

    // Date filter from inputStates
    const from = inputStates?.fromDate;
    const to = inputStates?.toDate;
    if (from && to) {
      whereConditions.push(
        `r.date BETWEEN '${formatDate(from)} 00:00:00' AND '${formatDate(to)} 23:59:59'`,
      );
    }

    // Employee filter from inputStates
    if (inputStates?.employeeIds?.length > 0) {
      whereConditions.push(
        `r.requesterId IN (${inputStates.employeeIds.join(",")})`,
      );
    }

    // Sub Types filter from inputStates
    if (inputStates?.subTypes?.length > 0) {
      const subTypeValues = inputStates.subTypes.map((s) => `'${s}'`).join(",");
      whereConditions.push(
        `r.id IN (SELECT requirementId FROM requirementPrices WHERE status = 1 AND subTypes IN (${subTypeValues}))`,
      );
    }

    // Disbursement Status filter from inputStates
    if (inputStates?.disbursementStatus?.length > 0) {
      const statusValues = inputStates.disbursementStatus
        .map((s) => (typeof s === "object" ? s.value : s))
        .join(",");
      whereConditions.push(`r.disbursedStatus IN (${statusValues})`);
    }

    // Job filter from inputStates
    if (inputStates?.selectedJobIds?.length > 0) {
      whereConditions.push(
        `r.jobId IN (${inputStates?.selectedJobIds.join(",")})`,
      );
    }

    // Permission logic
    const hasFullAccess = permissions.l1 || permissions.h1 || permissions.h2;
    const hasHod = permissions.hod;
    const hasL2 = permissions.l2;

    // ── Approve Status filter (only for hasFullAccess) ──
    if (inputStates?.approveStatus?.length > 0) {
      const approveConditions = inputStates.approveStatus
        .map((s) => {
          const val = typeof s === "object" ? s.value : s;
          if (val === "Approved") {
            return `(r.l1Status != 2 AND r.hodStatus != 2 AND r.h1Status != 2 AND r.h2Status = 1)`;
          } else if (val === "Rejected") {
            return `(r.l1Status = 2 OR r.hodStatus = 2 OR r.h1Status = 2 OR r.h2Status = 2)`;
          } else {
            return `(r.l1Status != 2 AND r.hodStatus != 2 AND r.h1Status != 2 AND r.h2Status != 2 AND r.h2Status != 1)`;
          }
        })
        .join(" OR ");
      whereConditions.push(`(${approveConditions})`);
    }

    if (hasFullAccess || (hasL2 && inputStates?.approveStatus?.length != 0)) {
      // Highest privilege — no restriction
    } else if (hasHod) {
      // HOD or HOD+L2 → scoped to their projects
      whereConditions.push(`jr.projectHodId = ${_employeeId}`);
    } else if (hasL2 && inputStates?.approveStatus?.length == 0) {
      // L2 only → see h2 approved records
      whereConditions.push("r.h2Status = 1");
    } else {
      // No special role → own requests only
      whereConditions.push(`r.requesterId = ${_employeeId}`);
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = (notPagination = false) => {
    const whereClause = getWhereClause();

    const paginationSettings =
      rowsPerPage !== -1
        ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`
        : "";

    // Separate join just for filtering by subTypes (doesn't affect allSubTypes)
    const subTypesFilterJoin =
      reportFilters?.subTypes?.length > 0
        ? `LEFT JOIN requirementPrices rp_filter ON r.id = rp_filter.requirementId AND rp_filter.status = 1 AND rp_filter.subTypes IN (${reportFilters.subTypes.map((s) => `'${s}'`).join(",")})`
        : "";

    return `SELECT r.*, r.date as reqDate, CASE WHEN r.disbursedStatus=1 THEN 'Disbursed' WHEN r.disbursedStatus=2 THEN 'Partially Disbursed' ELSE 'Pending' END AS disbursedStatus, CASE WHEN r.l1Status=1 THEN 'Approved' WHEN r.l1Status=2 THEN 'Rejected' WHEN r.hodStatus IN (1,2) THEN 'Overridden by HOD' WHEN r.h1Status IN (1,2) THEN 'Overridden by H1' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS l1ApproveStatus, CASE WHEN r.hodStatus=1 THEN 'Approved' WHEN r.hodStatus=2 THEN 'Rejected' WHEN r.h1Status IN (1,2) THEN 'Overridden by H1' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS hodApproveStatus, CASE WHEN r.h1Status=1 THEN 'Approved' WHEN r.h1Status=2 THEN 'Rejected' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS h1ApproveStatus, CASE WHEN r.h2Status=1 THEN 'Approved' WHEN r.h2Status=2 THEN 'Rejected' ELSE 'Pending' END AS h2ApproveStatus, CASE WHEN r.l1Status=2 OR r.hodStatus=2 OR r.h1Status=2 OR r.h2Status=2 THEN 'Rejected' WHEN r.h2Status=1 THEN 'Approved' ELSE 'Pending' END AS finalApproveStatus, jr.jobNumber AS jobNumber, jr.siteName AS siteName,jr.projectHodId, e.name AS requestedName, CONCAT(e_l1.name,'(',e_l1.employeesCode,')') AS l1Name, CONCAT(e_hod.name,'(',e_hod.employeesCode,')') AS hodName, CONCAT(e_h1.name,'(',e_h1.employeesCode,')') AS h1Name, CONCAT(e_h2.name,'(',e_h2.employeesCode,')') AS h2Name, ed.bankAccountNumber, ed.ifscCode, IFNULL(SUM(rp.amount),0) AS totalAmountOfReq, GROUP_CONCAT(DISTINCT rp.subTypes ORDER BY rp.id SEPARATOR ', ') AS allSubTypes,GROUP_CONCAT(DISTINCT CONCAT(rp.subTypes, ':|:', rp.description, ' (', rp.amount, ')') ORDER BY rp.id SEPARATOR '||') AS subTypeDetails , GROUP_CONCAT(CONCAT(rp.row_num, '. ', rp.description, ' (', rp.amount, ')') ORDER BY rp.row_num SEPARATOR ', ') AS allDescriptions FROM requirements r LEFT JOIN jobRegister jr ON r.jobId = jr.id LEFT JOIN employees e ON r.requesterId = e.id LEFT JOIN employeeDocuments ed ON e.id = ed.employeeId LEFT JOIN employees e_l1 ON r.l1Id = e_l1.id LEFT JOIN employees e_hod ON r.hodId = e_hod.id LEFT JOIN employees e_h1 ON r.h1Id = e_h1.id LEFT JOIN employees e_h2 ON r.h2Id = e_h2.id LEFT JOIN (SELECT rp.*, ROW_NUMBER() OVER (PARTITION BY rp.requirementId ORDER BY rp.id) AS row_num FROM requirementPrices rp WHERE rp.status = 1) rp ON r.id = rp.requirementId ${subTypesFilterJoin} ${whereClause} GROUP BY r.id ORDER BY r.id DESC  ${notPagination ? "" : paginationSettings} ;`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    const subTypesJoin =
      reportFilters?.subTypes?.length > 0
        ? `LEFT JOIN requirementPrices rp ON r.id = rp.requirementId AND rp.status = 1 AND rp.subTypes IN (${reportFilters.subTypes.map((s) => `'${s}'`).join(",")})`
        : "";

    return `SELECT COUNT(*) AS totalRows FROM requirements r LEFT JOIN jobRegister jr ON r.jobId = jr.id LEFT JOIN employees e ON r.requesterId = e.id LEFT JOIN employees e_l1 ON r.l1Id = e_l1.id LEFT JOIN employees e_hod ON r.hodId = e_hod.id LEFT JOIN employees e_h1 ON r.h1Id = e_h1.id LEFT JOIN employees e_h2 ON r.h2Id = e_h2.id ${subTypesJoin} ${whereClause};`;
  };
  const fetchData = async () => {
    try {
      const [RequirementData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setRequirementList(RequirementData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
      getAllExcelData();
    } catch (error) {
      console.error("Error fetching Requirement data:", error);
    }
  };

  const handleSearch = () => {
    // if ((!searchBy || !searchKey.trim()) && (!fromDate || !toDate)) {
    //   alert("Please provide a search value or select a date range.");
    //   return;
    // }

    fetchData();
    setSearched(true);
  };

  const fetchEmployeesData = async () => {
    try {
      let whereConditions = "";

      // 👤 User-type restriction
      // if (_userType !== 1 && _userType !== 2 && _userType !== 8) {

      const hasFullAccess = permissions.l1 || permissions.h1 || permissions.h2;

      if (!hasFullAccess && !permissions.l2) {
        whereConditions = ` WHERE e.id = ${_employeeId}`;
      }

      // 🏢 Department condition
      if (inputStates?.department) {
        whereConditions += whereConditions
          ? ` AND eod.department = '${inputStates.department}'`
          : ` WHERE eod.department = '${inputStates.department}'`;
      }

      // 🏬 Branch condition
      if (inputStates?.branch) {
        whereConditions += whereConditions
          ? ` AND eod.branchId = '${inputStates.branch}'`
          : ` WHERE eod.branchId = '${inputStates.branch}'`;
      }

      const Employees = await fetchQuery(`
        SELECT 
          e.id, 
          e.employeesCode, 
          e.name
        FROM employees e
        LEFT JOIN employeeOtherData eod 
          ON eod.employeeId = e.id
        ${whereConditions}
      `);

      setEmployeesData(Employees);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getJobData = async (employeeIds) => {
    try {
      const whereCondition =
        employeeIds && employeeIds.length > 0
          ? `WHERE r.requesterId IN (${employeeIds.join(",")})`
          : "";

      const result = await fetchQuery(
        `SELECT DISTINCT r.jobId, jr.jobNumber FROM requirements r LEFT JOIN jobRegister jr ON jr.id = r.jobId ${whereCondition}`,
      );
      setJobData(result);
    } catch (error) {
      console.error("Error fetching job data:", error);
    }
  };

  const getAllExcelData = async () => {
    try {
      const result = await fetchQuery(getDataQuery(true));
      setAllExcelData(result);
    } catch (error) {
      console.error("Error fetching excel data:", error);
    }
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
    setFromDate(null);
    setToDate(null);
    setInputStates({});
    setRequirementList([]);
    setReportFilters({});
  };

  useEffect(() => {
    fetchEmployeesData();
  }, []);

  useEffect(() => {
    getJobData(inputStates.employeeIds);
  }, [inputStates.employeeIds]);

  useEffect(() => {
    if (searched == true) {
      fetchData();
    }
  }, [currentPage, rowsPerPage, searched]);

  return (
    <>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        {/* {[1, 2, 8].includes(_userType) && ( */}
        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          // fullWidth
          options={[{ id: "ALL", name: "Select All" }, ...employeesData]}
          isOptionEqualToValue={(opt, val) => opt.id === val.id}
          getOptionLabel={(option) =>
            option.id === "ALL"
              ? "Select All"
              : `${option.employeesCode ? option.employeesCode + " - " : ""}${option.name}`
          }
          value={employeesData.filter((emp) =>
            inputStates.employeeIds?.includes(emp.id),
          )}
          onChange={(_, selected) => {
            updateInputObject(
              "employeeIds",
              selected.some((opt) => opt.id === "ALL")
                ? employeesData.map((e) => e.id)
                : selected.map((e) => e.id),
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.id === "ALL"
                    ? inputStates.employeeIds?.length === employeesData.length
                    : selected
                }
              />
              {option.id === "ALL"
                ? "Select All"
                : `${option.employeesCode ? option.employeesCode + " - " : ""}${option.name}`}
            </li>
          )}
          renderInput={(params) => <TextField {...params} label="Employee" />}
        />
        {/* )} */}

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={[{ jobId: "ALL", jobNumber: "Select All" }, ...jobData]}
          isOptionEqualToValue={(opt, val) => opt.jobId === val.jobId}
          getOptionLabel={(option) =>
            option.jobId === "ALL" ? "Select All" : `${option.jobNumber}`
          }
          value={jobData?.filter((job) =>
            inputStates.selectedJobIds?.includes(job.jobId),
          )}
          onChange={(_, selected) => {
            updateInputObject(
              "selectedJobIds",
              selected.some((opt) => opt.jobId === "ALL")
                ? jobData.map((j) => j.jobId)
                : selected.map((j) => j.jobId),
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.jobId === "ALL"
                    ? inputStates.selectedJobIds?.length === jobData.length
                    : selected
                }
              />
              {option.jobId === "ALL" ? "Select All" : `${option.jobNumber}`}
            </li>
          )}
          renderInput={(params) => <TextField {...params} label="Select Job" />}
        />

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={["Select All", ...SUBTYPE_OPTIONS]}
          value={inputStates.subTypes || []}
          onChange={(_, selected) => {
            const isAll = selected.includes("Select All");
            updateInputObject(
              "subTypes",
              isAll
                ? [...SUBTYPE_OPTIONS]
                : selected.filter((s) => s !== "Select All"),
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option === "Select All"
                    ? inputStates.subTypes?.length === SUBTYPE_OPTIONS.length
                    : selected
                }
              />
              {option}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select subtype" />
          )}
        />

        {/* From Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="From Date"
            value={inputStates.fromDate || null}
            onChange={(val) => updateInputObject("fromDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        {/* To Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="To Date"
            value={inputStates.toDate || null}
            onChange={(val) => updateInputObject("toDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={[
            { label: "Select All", value: "ALL" },
            ...DISBURSEMENT_OPTIONS,
          ]}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          value={DISBURSEMENT_OPTIONS.filter((opt) =>
            inputStates.disbursementStatus?.some((s) => s.value === opt.value),
          )}
          onChange={(_, selected) => {
            const isAll = selected.some((opt) => opt.value === "ALL");
            updateInputObject(
              "disbursementStatus",
              isAll
                ? [...DISBURSEMENT_OPTIONS]
                : selected.filter((s) => s.value !== "ALL"),
            );
            setSearched(false);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.value === "ALL"
                    ? inputStates.disbursementStatus?.length ===
                      DISBURSEMENT_OPTIONS.length
                    : selected
                }
              />
              {option.label}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Disbursement Status"
              placeholder="Select status"
            />
          )}
        />

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={[{ label: "Select All", value: "ALL" }, ...STATUS_OPTIONS]}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          value={STATUS_OPTIONS.filter((opt) =>
            inputStates.approveStatus?.some((s) => s.value === opt.value),
          )}
          onChange={(_, selected) => {
            const isAll = selected.some((opt) => opt.value === "ALL");
            updateInputObject(
              "approveStatus",
              isAll
                ? [...STATUS_OPTIONS]
                : selected.filter((s) => s.value !== "ALL"),
            );
            setSearched(false);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.value === "ALL"
                    ? inputStates.approveStatus?.length ===
                      STATUS_OPTIONS.length
                    : selected
                }
              />
              {option.label}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Approve Status"
              placeholder="Select status"
            />
          )}
        />

        <SearchToggleButton
          searched={searched}
          onSearch={handleSearch}
          onClear={clearSearch}
        />
      </div>

      <div className="flex gap-3">
        <RequirementExcelDownload
          requirementList={allExcelData}
          excelHeaders={excelHeaders}
          buttonLabel={"Bank Sheet"}
        />

        <RequirementExcelDownload
          requirementList={allExcelData}
          excelHeaders={requirementExcelHeaders}
          buttonLabel={"Requirement Sheet"}
        />
      </div>

      <br />
      <br />
      <ListView
        headers={headers}
        data={requirementList}
        actions={{}}
        showCheckbox={true}
        deleteTableName={"requirements"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
        rowsPerPageOptions={[30, 50, 100, -1]}
      />
    </>
  );
};

export default RequirementReport;
